module.exports = __webpack_public_path__ + "static/media/Pods_desktop_article_7.8f0a8bad.jpg";